
<template>
<markdown-render v-if="guide" :source="guide"></markdown-render>
</template>

<script>
import { mapState } from "vuex"
import MarkdownRender from "../../MarkdownRender"

export default {
  components:{
    "markdown-render": MarkdownRender
  },

  computed: {
    ...mapState(
      {
          http: state => state.metadata.backendApi.http[state.metadata.env]
      }
    )
  },
  data(){
    return {
      guide: null
    }
  },

  mounted(){
    this.guide = guide.replace("{{host}}",this.http.host).replace("{{basePath}}",this.http.basePath);
  }
  
}



const guide = "                                                                     \n\
# Getting started for HTTP generic devices                                          \n\
## Configure asset-tracking dashboard                                               \n\
1. From **devices** view register a new *HTTP* device by providing:                   \n\
    - Human-friendly label                                                              \n\
    - Device ID                                                                         \n\
\n\
2. Create an api-key from **settings** view                                \n\
## Send data                                                                        \n\
Send HTTP request with telemetry data:\n\
- URL: `https://{{host}}/{{basePath}}/telemetry`\n\
- Headers:\n\
  - `Authorization` header set equal to asset-tracking api-key previously created\n\
  - `Content-type: application/json` \n\
- Body \n\
```json \n\
\n\
  {\n\
    \"device_id\":\"<device ID>\",\n\
    \"values\":[\n\
      {\"ts\":<epoch milliseconds>,\"t\": \"tem\", \"v\": 25.52},\n\
      {\"ts\":<epoch milliseconds>,\"t\": \"hum\", \"v\": 80.1},\n\
      {\"ts\":<epoch milliseconds>,\"t\": \"pre\", \"v\": 1000},\n\
      {\"ts\":<epoch milliseconds>,\"t\": \"acc\", \"v\": { \"x\": 0.1, \"y\": 0.1, \"z\": 0.1 }},\n\
      {\"ts\":<epoch milliseconds>,\"t\": \"gyr\", \"v\": { \"x\": 0.1, \"y\": 0.1, \"z\": 0.1 }},\n\
      {\"ts\":<epoch milliseconds>,\"t\": \"mag\", \"v\": { \"x\": 0.1, \"y\": 0.1, \"z\": 0.1 }},\n\
      {\"ts\":<epoch milliseconds>,\"t\": \"gnss\", \"v\": { \"lat\": 0.1, \"lon\": 0.1, \"ele\": 0.1 }},\n\
      {\"ts\":<epoch milliseconds>,\"t\": \"evt\", \"v\": { \"et\": \"threeshold\", \"m\": \"ORIENTATION\", \"l\": \"TOP\", \"msg\": \"Device changed its orientation\" } }\n\
    ]\n\
  }\n\
"
</script>